module.exports = __webpack_public_path__ + "static/media/sunarch.26bb3eea.jpg";